export const TRIVIA_BUILDER_MOCK_IMAGES: string[] = [
  `${process.env.REACT_APP_CLOUDFRONT_URL}/battleQuestion1-Image1.png`,
  `${process.env.REACT_APP_CLOUDFRONT_URL}/battleQuestion1-Image2.png`,
  `${process.env.REACT_APP_CLOUDFRONT_URL}/battleQuestion1-Image3.png`,
  `${process.env.REACT_APP_CLOUDFRONT_URL}/battleQuestion1-Image4.png`,
  `${process.env.REACT_APP_CLOUDFRONT_URL}/triviaBuilder-addy.png`
];
